export function fingerprint(value: unknown): string {
  const text = JSON.stringify(value);
  let hash = 2166136261;
  for (let i = 0; i < text.length; i++) hash = Math.imul(hash ^ text.charCodeAt(i), 16777619);
  return (hash >>> 0).toString(36);
}
export function readBrowserState<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}
export function writeBrowserState(key: string, value: unknown): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    window.dispatchEvent(new CustomEvent("learning-storage", { detail: key }));
    return true;
  } catch {
    return false;
  }
}
export interface StudyPosition {
  version: string;
  conceptId: string;
  courseId: string;
  step: 1 | 2 | 3;
  anchor: string;
  offset: number;
  updatedAt: string;
}
export const studyKey = (user: string, concept: string) => `english:study:${user}:${concept}`;
export const lastStudyKey = (user: string) => `english:last-study:${user}`;
